// extracted by mini-css-extract-plugin
export default {"overlay":"Uy-z","bodyOpen":"Vy-z","content":"Wy-z","header":"Xy-z","close":"Yy-z","closeNoHeading":"Zy-z"};